module.exports = __webpack_public_path__ + "static/media/Airbrake_MX_Remove-simpChinese.88b8841f.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/screens/switchlock/video/sc/Airbrake_MX_Remove-simpChinese.mp4
// module id = 3488
// module chunks = 0